import { features } from '@ui/components/Features';
import { isFeatureEnabled } from '@ui/hooks/useIsFeatureEnabled';
import { getStaticProps as getStaticI18nProps } from '@ui/i18n/getStatic';
import {
  fetchContentfulArticle,
  fetchContentfulArticles,
} from '@ui/queries/contentfulArticle';
import type { ArticleUiType } from '@ui/views/Article/types';
import type {
  GetStaticPaths,
  GetStaticProps,
  GetStaticPropsResult,
} from 'next';

export { Article as default } from '@ui/views/Article';

export const getStaticProps: GetStaticProps = async ({
  params,
}): Promise<
  | { notFound: true }
  | {
      props: {
        article: ArticleUiType;
        articles: {
          slug: string;
          title: string;
        }[];
      };
    }
> => {
  // feature is disabled -> 404
  // https://nextjs.org/docs/pages/api-reference/functions/get-static-props#notfound
  if (!isFeatureEnabled(features.contentfulMarketingArticles)) {
    return {
      notFound: true,
    };
  }

  const article = (await fetchContentfulArticle(params?.slug as string))[0];
  const articles = await fetchContentfulArticles();
  const i18nProps = (await getStaticI18nProps({ params })) as Extract<
    GetStaticPropsResult<{ [key: string]: unknown }>,
    { props: unknown }
  >;
  return { props: { article, articles, ...i18nProps.props } };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs = await fetchContentfulArticles(false);

  return {
    paths: slugs.map(({ slug }) => ({ params: { slug } })),
    fallback: false,
  };
};
